
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3g0Pk", function(module, exports) {
$parcel$export(module.exports, "BrowserStorageControlsInit", () => $bd0974be2f016f9b$export$1e5524c82dfa4c29);

var $eJOHy = parcelRequire("eJOHy");

var $gOhYy = parcelRequire("gOhYy");
const $bd0974be2f016f9b$export$1e5524c82dfa4c29 = ()=>{
    (0, $eJOHy.useEffect)(()=>{
        (0, $gOhYy.initControlsOnce)();
    }, []);
    return null;
};

});
parcelRegister("gOhYy", function(module, exports) {
$parcel$export(module.exports, "initControlsOnce", () => $d1edc620a3250b22$export$1120113854b04415);

var $aXqXi = parcelRequire("aXqXi");

var $4cTDP = parcelRequire("4cTDP");

var $aSDDo = parcelRequire("aSDDo");

var $SvJbY = parcelRequire("SvJbY");
let $d1edc620a3250b22$var$initializeControlsPromise = null;
function $d1edc620a3250b22$export$1120113854b04415() {
    if (!$d1edc620a3250b22$var$initializeControlsPromise) {
        if ((0, $4cTDP.fg)('fedramp-cookies-controls')) $d1edc620a3250b22$var$initializeControlsPromise = (0, $aXqXi.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration'),
            perimeter: (0, $aSDDo.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        });
        else $d1edc620a3250b22$var$initializeControlsPromise = (0, $aXqXi.initializeControls)({
            product: 'Jira',
            webStorageEnabled: (0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')
        });
    }
    return $d1edc620a3250b22$var$initializeControlsPromise;
}
(0, $SvJbY.autoBeforeEachTest)(()=>{
    $d1edc620a3250b22$var$initializeControlsPromise = null;
});

});
parcelRegister("aXqXi", function(module, exports) {
$parcel$export(module.exports, "initializeControls", () => $4019da99ccdb6247$export$919040c32a62c7db);

var $91hOG = parcelRequire("91hOG");

var $kNo2r = parcelRequire("kNo2r");
var $h4HIa = parcelRequire("h4HIa");
var $l7dDt = parcelRequire("l7dDt");

var $5q7fY = parcelRequire("5q7fY");

var $kcWaq = parcelRequire("kcWaq");

var $1E6vf = parcelRequire("1E6vf");

var $fyxLT = parcelRequire("fyxLT");
const $4019da99ccdb6247$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $91hOG.fg)('platform_moonjelly_bsc_master_killswitch')) // Exit if the master killswitch is enabled
    return;
    try {
        (0, $l7dDt.Logger).debug('initializeControls invoked');
        (0, $5q7fY.initializeGlobalState)(args);
        // Exit silently if in SSR context
        if ((0, $h4HIa.isSSR)()) return;
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $kNo2r.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $1E6vf.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $5q7fY.getBscGlobalState)().webStorageEnabled;
        if (!isWebStorageControlsEnabled) return;
        await (0, $fyxLT.createWebStoragePassthrough)((0, $kcWaq.WebStorageType).LocalStorage);
        await (0, $fyxLT.createWebStoragePassthrough)((0, $kcWaq.WebStorageType).SessionStorage);
        (0, $l7dDt.Logger).debug('initiizeControls finished');
    } catch (e) {
        (0, $l7dDt.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
};

});
parcelRegister("1E6vf", function(module, exports) {
$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $089a7662fd6af13d$export$45a5573b04db016c);

var $l7dDt = parcelRequire("l7dDt");

var $lq55Z = parcelRequire("lq55Z");
const $089a7662fd6af13d$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $l7dDt.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $lq55Z.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

});
parcelRegister("lq55Z", function(module, exports) {
$parcel$export(module.exports, "getSetCookieOverride", () => $014937bafac0bcdf$export$b7364c41ddbfdb0a);

var $5q7fY = parcelRequire("5q7fY");
var $kNo2r = parcelRequire("kNo2r");

var $fcq8B = parcelRequire("fcq8B");

var $l7dDt = parcelRequire("l7dDt");

var $6OXGN = parcelRequire("6OXGN");
const $014937bafac0bcdf$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $l7dDt.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $kNo2r.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $5q7fY.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, $fcq8B.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $5q7fY.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else return;
                    },
                    storageType: (0, $6OXGN.CategoryStorageType).Cookies,
                    productName: productName
                });
            } catch (e) {
                (0, $l7dDt.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $l7dDt.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

});


parcelRegister("fyxLT", function(module, exports) {
$parcel$export(module.exports, "createWebStoragePassthrough", () => $0a44fcfc1e63e3ed$export$619fe705922e5d61);

var $l7dDt = parcelRequire("l7dDt");

var $2mnSF = parcelRequire("2mnSF");

var $kcWaq = parcelRequire("kcWaq");

var $7Jivm = parcelRequire("7Jivm");
const $0a44fcfc1e63e3ed$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $kcWaq.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $l7dDt.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $2mnSF.BSCIndexedDB).isAvailable) {
        (0, $l7dDt.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $2mnSF.BSCIndexedDB).isBooted) // If we've yet to invoke booting of the IDB service, ensure we do it here.
    await (0, $2mnSF.BSCIndexedDB).boot();
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $7Jivm.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, $kcWaq.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

});
parcelRegister("7Jivm", function(module, exports) {
$parcel$export(module.exports, "setItemOverride", () => $49212c763bd5fe3d$export$b4469df6294ea6aa);

var $5q7fY = parcelRequire("5q7fY");
var $kNo2r = parcelRequire("kNo2r");

var $fcq8B = parcelRequire("fcq8B");

var $l7dDt = parcelRequire("l7dDt");

var $kcWaq = parcelRequire("kcWaq");

var $6OXGN = parcelRequire("6OXGN");
const $49212c763bd5fe3d$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        bscStorage.checkIfSetByPackage({
            itemKey: originalItemKey,
            isSetCallback: ()=>{
                itemSetByPackage = true;
            },
            isNotSetCallback: ()=>{
                // Note: This is async and could fail, but if the call errors out in IDB,
                // it will forcibly resolve to false here, so we're not catching the error again here ✅
                itemSetByPackage = false;
            }
        });
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $l7dDt.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                }
            });
        }
        try {
            (0, $kNo2r.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType
                }
            });
            try {
                const productName = (0, $5q7fY.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, $fcq8B.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ()=>{
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $5q7fY.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else return;
                    },
                    storageType: storageType === (0, $kcWaq.WebStorageType).LocalStorage ? (0, $6OXGN.CategoryStorageType).LocalStorage : (0, $6OXGN.CategoryStorageType).SessionStorage,
                    productName: productName
                });
            } catch (e) {
                (0, $l7dDt.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType
                    }
                });
            }
        } catch (e) {
            (0, $l7dDt.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`
            });
        }
    };

});






//# sourceMappingURL=async-browser-storage-controls-init.14ed0d06.js.map
